export const contact = {
  it: {
    title: "Contattami",
    hero: {
      title: "CANALE",
      titleHighlight: "DIRETTO",
      subtitle: "Nessun intermediario. Nessun ticket system.",
      subtitleHighlight: "Accesso diretto all'architetto del sistema.",
      connecting: "ESTABLISHING UPLINK...",
      connected: "SECURE CONNECTION ESTABLISHED"
    },
    access: {
      title: "Protocolli di Accesso",
      whatsapp: {
        priority: "Priority",
        responseTime: "AVG RES: 12m",
        label: "WhatsApp Diretto"
      },
      email: {
        label: "Async Channel"
      },
      linkedin: {
        label: "Professional Network"
      }
    },
    status: {
      title: "Onboarding Q3 Aperto",
      description: "Attualmente sto valutando nuovi progetti. La priorità viene data alle aziende pronte per una ristrutturazione completa dei processi."
    },
    map: {
      title: "La nostra sede",
      alt: "Mappa della sede di Victor Lazari",
      signal: "SIGNAL_STRENGTH: 100%",
      location: "RAVENNA",
      locationSubtitle: "HQ Operations Center",
      secureFacility: "Secure Facility",
      secureDescription: "Tutte le operazioni sono monitorate e protette. I dati dei clienti sono conservati su infrastrutture compliant GDPR con crittografia end-to-end."
    },
    info: {
      title: "Informazioni di Contatto",
      whatsapp: {
        title: "WhatsApp",
        number: "+39 380 633 1704"
      },
      email: {
        title: "Email",
        address: "victor@victorlazari.com"
      },
      location: {
        title: "Sede",
        address: "San Pietro in Vinoli, Ravenna, 48125, Italia"
      },
      linkedin: {
        title: "LinkedIn",
        username: "Victor Lazari"
      }
    },
    whatsappButton: "Contattami su WhatsApp"
  },
  en: {
    title: "Get in Touch",
    hero: {
      title: "DIRECT",
      titleHighlight: "CHANNEL",
      subtitle: "No intermediaries. No ticket system.",
      subtitleHighlight: "Direct access to the system architect.",
      connecting: "ESTABLISHING UPLINK...",
      connected: "SECURE CONNECTION ESTABLISHED"
    },
    access: {
      title: "Access Protocols",
      whatsapp: {
        priority: "Priority",
        responseTime: "AVG RES: 12m",
        label: "Direct WhatsApp"
      },
      email: {
        label: "Async Channel"
      },
      linkedin: {
        label: "Professional Network"
      }
    },
    status: {
      title: "Q3 Onboarding Open",
      description: "I'm currently evaluating new projects. Priority is given to companies ready for a complete process restructuring."
    },
    map: {
      title: "Our Location",
      alt: "Victor Lazari's office location map",
      signal: "SIGNAL_STRENGTH: 100%",
      location: "RAVENNA",
      locationSubtitle: "HQ Operations Center",
      secureFacility: "Secure Facility",
      secureDescription: "All operations are monitored and protected. Client data is stored on GDPR-compliant infrastructures with end-to-end encryption."
    },
    info: {
      title: "Contact Information",
      whatsapp: {
        title: "WhatsApp",
        number: "+39 380 633 1704"
      },
      email: {
        title: "Email",
        address: "victor@victorlazari.com"
      },
      location: {
        title: "Location",
        address: "San Pietro in Vinoli, Ravenna, 48125, Italy"
      },
      linkedin: {
        title: "LinkedIn",
        username: "Victor Lazari"
      }
    },
    whatsappButton: "Contact Me on WhatsApp"
  }
};